<template>
    <div>
        <b-input-group class="mb-2">
            <template #prepend>
                <b-input-group-text class="bg-light">Size</b-input-group-text>
            </template>
            <b-form-select v-model="qr_code_size" :options="qrCodeOptions"></b-form-select>
        </b-input-group>

        <span v-show="qr_loading"><i class="fa fa-spin fa-spinner"></i></span>

        <div v-show="!qr_loading">
            <img :src="`data:image/png;base64,${qr_code_html}`" />
        </div>

        <div class="mt-3">
            <a href="javascript:void(0)" v-on:click="downloadQrCode()" target="_blank">Download QR Code</a>
        </div>

        <div class="mt-1" v-if="show_url">
            <a :href="qr_code_url" target="_blank">{{ qr_code_url }}</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            qr_code_url: {
                type: String,
                require: true,
            },

            qr_code_name: {
                type: String,
                default: null,
            },

            show_url: {
                type: Boolean,
                default: false,
            },

            qr_code_size: {
                type: Number,
                default: 5,
            },
        },

        data() {
            return {
                qr_loading: false,
                qr_code_html: null,
                qrCodeOptions: [
                    {value: 3, text: '87x87'},
                    {value: 4, text: '116x116'},
                    {value: 5, text: '145x145'},
                    {value: 6, text: '174x174'},
                    {value: 7, text: '203x203'},
                    {value: 8, text: '232x232'},
                    {value: 9, text: '261x261'},
                ],
            }
        },

        watch: {
            qr_code_size(newVal, oldVal){
                //Get the QR Code
                this.getQrCode();
            },
        },

        methods: {

            getQrCode(){
                //QR Code
                this.qr_loading = true;

                //Setup
                var payload = {
                    qr_code_size: this.qr_code_size,
                    qr_code_url: this.qr_code_url,
                    qr_code_name: this.qr_code_name,
                };

                //Get the data
                this.$http
                    .get('/qr-code', payload)
                    .then(response => {
                        //Set all the data
                        this.qr_code_html = response.data.qr_code;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.qr_loading = false;
                    });
            },

            downloadQrCode(){
                //Open it
                window.open('/qr-code?download=true&qr_code_size='+this.qr_code_size+'&qr_code_name='+encodeURIComponent(this.qr_code_name)+'&qr_code_url='+encodeURIComponent(this.qr_code_url), '_blank');
            }

        },

        mounted() {
            //Get it
            this.getQrCode();
        }
    }
</script>
